const PageEndIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      width="100%"
      viewBox="0 0 11.644 12.246"
      className="stroke-current"
    >
      <g
        id="Group_9623"
        data-name="Group 9623"
        transform="translate(-1378.856 -1411.588)"
      >
        <path
          id="Path_12208"
          data-name="Path 12208"
          d="M2532.279-16715.273l6.475,5.826-6.475,4.877"
          transform="translate(-1152.754 18127.605)"
          fill="none"
          strokeWidth={2}
        />
        <line
          id="Line_227"
          data-name="Line 227"
          y1={11}
          transform="translate(1389.5 1412.5)"
          fill="none"
          strokeWidth={2}
        />
      </g>
    </svg>
  )
}

export default PageEndIcon
